import { useContext } from 'react';
import { getValue } from './data_storage';
import { commonModules } from '.';

const useTranslateText = () => {
  const { storeContext, UserContext } = commonModules;
  const { state } = useContext(storeContext),
        context = useContext(UserContext),
        { User_Data: { TranslatedText = false } = false } = state || getValue('User_Data') || {},
        { LangCode = false } = state || {};

  const memoize = (fn) => {
    return (...args) => {
      const n = args[0]; // just taking one argument here
      let cache = context.cache || {};
      if (LangCode !== 'EN') {
        if (n in cache) {
          return cache[n];
        }
        else {
          let result = fn(n);
          if (!result.shouldMemoize) {
            return result.Text;
          }
          cache[n] = result.Text;
          context.cache = { ...cache };
          return result.Text;
        }
      }
      else {
        return n;
      }
    };
  };

  const translateEnText = (text) => {
    let Text = text;
    let shouldMemoize = false;
    if (LangCode !== 'EN' && Text && TranslatedText) {
      let foundTranslatedText = false;
      TranslatedText.TranslatedData.map((p) => {
        if (p.ElementValue.toUpperCase().replace(/\n|\\/g, '').replace(/\s\s+/g, ' ').trim() ===
          text.toUpperCase().replace(/\n|\\/g, '').replace(/\s\s+/g, ' ').trim()) {
          Text = p.Translatevalue;
          foundTranslatedText = true;
          shouldMemoize = true;
        }
      });
      if (!foundTranslatedText && isNaN(Text)) {
        let reqGoogleTranslation = context.reqGoogleTranslation || '';
        const newWord = reqGoogleTranslation.split('&q=').indexOf(Text.replace(/\n|\\/g, '').replace(/\s\s+/g, ' ').trim()) === -1;
        if (newWord) {
          reqGoogleTranslation += ('&q=' + Text.replace(/\n|\\/g, '').replace(/\s\s+/g, ' ').trim());
          context.reqGoogleTranslation = reqGoogleTranslation;
        }
      }
    }
    return {
      Text,
      shouldMemoize,
    };
  };

  const translateText = memoize(translateEnText);

  return {
    translateText,
  };
};

export default useTranslateText;